// Configuração centralizada da API
// Este arquivo centraliza todas as configurações relacionadas à API

// Base URL da API - OBRIGATÓRIA via variável de ambiente
// const API_BASE_URL = 'http://bds-backend.test/api/v1'
// Fallback para produção/staging quando variável não estiver definida
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

// Configurações da API
export const apiConfig = {
  // URL base da API
  baseURL: API_BASE_URL,
  
  // Timeout padrão para requisições (30 segundos)
  timeout: 30000,
  
  // Timeout para uploads de arquivos grandes (30 minutos)
  uploadTimeout: 30 * 60 * 1000,
  
  // Headers padrão
  defaultHeaders: {
    'Content-Type': 'application/json'
  },
  
  // Configurações de autenticação
  auth: {
    tokenType: 'Bearer',
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken'
  },
  
  // Endpoints específicos
  endpoints: {
    login: '/auth/login',
    register: '/auth/register',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    googleLogin: '/auth/google',
    googleRegister: '/auth/google/register'
  }
}

// URL completa para diferentes contextos
export const getApiUrl = (endpoint = '') => {
  return `${API_BASE_URL}${endpoint}`
}

// URL base sem /api/v1 para proxy e outras configurações
export const getBaseServerUrl = () => {
  return API_BASE_URL.replace('/api/v1', '')
}

export default apiConfig

// Compatibilidade com CommonJS para vite.config.js
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    apiConfig,
    getApiUrl,
    getBaseServerUrl
  }
}
